/*
 * DSO stands for Distribution System Operator
 * TSO stands for Transport System Operator
 */
export enum GridOperatorType {
  'DSO' = 'DSO',
  'TSO' = 'TSO',
}
